import React, { useContext } from 'react';
import HeaderNavBarContext from '../context/HeaderNavBarContext';
import UserLinks from './UserLinks';
import Box from '../../../components/Box/Box';
import { Link } from '../../../components/Link';
import { Title5 } from '../../../components/Title';
import { TNavBar } from '../../../types/THeaderConfig';

const getLogoAltText = (text?: string) => text ?? window?.location?.hostname ?? 'Homepage logo';

const NavBar = ({
  showHamburgerMenu,
  menuLinks,
  trackGAEvent,
  logoMobileSrc,
  logoDesktopSrc,
  translations,
  wrapHeadLogoH1Tag,
}: TNavBar) => {
  const { headerLinks, userLinks } = useContext(HeaderNavBarContext);

  const onClickHandler = (index: number) => {
    if (trackGAEvent) {
      trackGAEvent('header-link-clicked', index.toString());
    }
  };

  const HeaderLogoMarkup = (
    <Link className="hz-Header-logo" href="/" data-role="homepage" aria-label="Homepage" tabIndex={0}>
      <img src={logoDesktopSrc} className="hz-Header-logo-desktop" alt={getLogoAltText(translations?.logoAltText)} />
      <img src={logoMobileSrc} className="hz-Header-logo-mobile" alt={getLogoAltText(translations?.logoAltText)} />
    </Link>
  );

  return (
    <Box as="div" parent="Header" name="navBar" className="hz-Header-bigger-touchAreas">
      <Box as="div" parent="Header" name="maxWidth">
        {wrapHeadLogoH1Tag ? <Title5 as="h1">{HeaderLogoMarkup}</Title5> : [HeaderLogoMarkup]}
        {headerLinks && (
          <Box as="ul" parent="Header" name="links">
            {headerLinks.map(({ text, url }, index) => (
              <li key={text}>
                <Link href={url} onClick={() => onClickHandler(index)} tabIndex={0}>
                  {text}
                </Link>
              </li>
            ))}
          </Box>
        )}
        {userLinks && <UserLinks showHamburgerMenu={showHamburgerMenu} menuLinks={menuLinks} />}
      </Box>
    </Box>
  );
};

export default NavBar;
